<template>
  <div class="svg-wrap" ref="svgWrap">
    <svg
      version="1.1"
      baseProfile="full"
      height="100%"
      :width="svgWidth"
      xmlns="http://www.w3.org/2000/svg"
      class="def-block-svg scrollbar"
      ref="defBlockSvg"
    >
      <g class="blocklyEditableText" transform="translate(20,20)">
        <path x="50%" y="30" stroke="#2257bf" fill="#409EFF" :d="pathD" />
        <foreignObject
          rx="5"
          ry="5"
          y="50"
          x="12"
          width="100%"
          height="150px"
          class="create-text-wrap"
        >
          <!-- 积木名称 -->
          <el-input
            class=" block-param input-block-name"
            type="text"
            :style="{ width: textWidth + 'px', height: '20px' }"
            v-model.trim="paramText"
            placeholder="积木名称"
          />
          <!-- 积木参数变量 -->
          <div
            class="block-param-wrap input-block-param"
            v-for="(param, index) in paramArr"
            :key="index"
          >
            <span class="del-param" @click="delParam(index)" v-if="activeIndex ===index">
              <img :src='delIcon' alt="">
              <!-- 删除 -->
            </span>
            <el-input
              :class="[
                'block-param',
                'input-block-param',
                param.attr === 'paramLabel' ? 'param-label' : ''
              ]"
              type="text"
              :style="{ width: param.textWidth + 'px', height: '20px' }"
              v-model.trim="param.paramText"
              placeholder=" text or number"
              @input="getParamChange(index)"
              @mouseenter.native="getActiveIndex(index)"
            >
            </el-input>
          </div>
        </foreignObject>
      </g>
    </svg>
  </div>
</template>
<script>
import bus from "@/utils/bus";
export default {
  props: {
    paramArr: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  model: {
    prop: "paramArr",
    event: "change"
  },
  data() {
    return {
      paramText: "",
      initWidth: 80,
      textWidth: 90,
      initParamWidth: 90,
      minWidth: 180,
      pathD: `m 10,5  h 80  l 20,20  h 100 l 15,15 l 0,30 l -15,15 H10 Z`,
      padthArr: [
        "m 10,5",
        "h 80",
        "l 25,25",
        "h",
        "l 25,25",
        "l 0,30",
        "l -25,25",
        "H10",
        "Z"
      ],
      textwidthSum: 0,
      oldParamArr: [], //上一次传入的参数数组
      svgWidth: "100%",
      delIcon: require("@/assets/images/icon_delete.png"),
      activeIndex:null,
    };
  },
  watch: {
    paramArr: {
      handler(val) {
        let oldParamArr = this.oldParamArr;
        if (val.length > oldParamArr.length) {
          //增加或减少参数时的处理
          // this.$nextTick()
          this.getNewBlockWidth(this.initParamWidth);
        } else {
          //修改参数变量的处理
          this.getNewBlockWidth();
        }
        this.oldParamArr = JSON.parse(JSON.stringify(val));
      },
      deep: true,
      immediate: true
    },
    paramText(newVal, oldVal) {
      let len = newVal.length,
        textWidth;
        let strLen=this.countStrLen(newVal)
      if (newVal !== oldVal) {
        textWidth = this.initWidth + strLen;
        this.textWidth = textWidth;
        this.getNewBlockWidth();
        this.$emit("getDefineLabelName", newVal);
      }
    }
  },
  
  created() {
    bus.$on("initDefBlockName", () => {
      this.paramText = "";
    });
  },
  methods: {
    inputChange(e) {},
    //更新blockly的宽度值;
    initPath() {
      this.padthArr[3] = "h";
    },
    delParam(index){
      let {paramArr} =this;
      paramArr.splice(index,1);
      this.paramArr =paramArr;
    },
    updatePath() {},
    //参数更改
    getParamChange(index) {
      let { paramArr } = this;
      let textWidth = paramArr[index].textWidth;
      let paramText = paramArr[index].paramText;
      let len = paramText.length;
    let strLen=this.countStrLen(paramText);//为了区分单字节字符和双字节字符
      this.$nextTick(() => {
        paramArr[index].textWidth = 20 + strLen;
        // paramArr[index].textWidth = 20 + len * 7;
      });
      this.$emit("getDefineParamArr", paramArr);
    },
    //计算字节长度、区分双字节和单字节，依据14px大小字体来计算
    countStrLen(str){
       let strLen=0 ;
       for(let char of str){
         //双字节的计算
	  if(/[^\x00-\xff]/.test(char)){
       strLen += 14;
   }else{
     //单字节的计算
    strLen += 7;
  }
 }
      return strLen;
    },
    getActiveIndex(index){
this.activeIndex =index;
    },
    getNewBlockWidth() {
      const { paramArr } = this;
      let textwidthSum = 0,
        inputLabelNodes = document.querySelector(
          ".create-text-wrap .input-block-name"
        );
      //加标签名称输入框的宽度
      if (inputLabelNodes) {
        textwidthSum += inputLabelNodes.offsetWidth;
      } else {
        textwidthSum += this.initWidth;
      }

      //加各个参数输入框的宽度
      for (let item of paramArr) {
        let len = item.paramText.length;
        textwidthSum = textwidthSum + item.textWidth+20
      }

      textwidthSum = textwidthSum + 20;
      this.textwidthSum = textwidthSum;
      this.padthArr[3] = "h" + textwidthSum;
      this.pathD = this.padthArr.join(""); // 重新生成积木路径
      this.$forceUpdate(); //强制刷新;

      // 改变整个积木的宽度
      this.updateSvgWidth(textwidthSum);
    },
    updateSvgWidth(textwidthSum) {
      let svgWrap = this.$refs.svgWrap;
      let defBlockSvg = this.$refs.defBlockSvg;
      if (defBlockSvg) {
        let svgWrapWidth = svgWrap.offsetWidth;
        let svgWidth = defBlockSvg.offsetWidth;
        if (textwidthSum > 800) {
          this.svgWidth = svgWrapWidth + textwidthSum - 800;
          // debugger;
        }else {
          this.svgWidth ='100%';
        }
      }
      // debugger;
    },
    // 处理paramArr最后一个参数变量的宽度;
    TextWidthHandler() {
      // const { paramArr } = this;
      // if (paramArr.length > 0) {
      //   let inputNodes = document.querySelectorAll(
      //     ".create-text-wrap .block-param"
      //   );
      //   let lastInput = inputNodes[inputNodes.length - 1];
      //   let len = paramArr[paramArr.length - 1].paramText.length;
      //   lastInput.style.width = 7 * len + 20 + "px";
      // }
    }
  }
};
</script>
<style scoped lang="scss">
.svg-wrap {
  width: 100%;
  overflow: auto;
  font-size: 14px;
  border-bottom: 1px solid #ddd;
  .create-text-wrap {
    display: inline-block;
    ::v-deep.el-input__inner {
      height: 30px;
      line-height: 30px;
      font-size: 14px;
    }
  }
  .input-block-name {
    margin-left: 20px;
    margin-right: 10px;
    transform: translateY(0px);
  }
  .block-param-wrap {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // transform: translateY(-22px);
    // height: 80px;
    .del-param {
      display: inline-block;
      position: absolute;
      z-index: 9999;
      color: #fff;
      top: 33px;
      width:20px;
      height: 20px;
      cursor: pointer;
      img{width:100%;height: 100%;}
    }
  }
  .input-block-param {
    margin-left: 10px;
    ::v-deep.el-input__inner {
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      border-radius: 15px;
      padding: 0 5px;
      text-align: center;
      transition: all 0.3s;
    }
    &.param-label {
      ::v-deep.el-input__inner {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        border-radius: 4px;
        transition: all 0.3s;
      }
    }
  }
}
</style>
